/**
 *
 * @param href - url slug
 * @returns URL with leading slash (if it's not already present) or empty string if href is falsy
 */
export default function normalizeHref(href?: string): string {
  if (!href) {
    return "";
  }
  return href.startsWith("/") ? href : `/${href}`;
}
